export default class CreateRoleCtrl {

  constructor ($scope, $timeout, $mdDialog, $stateParams, WorkPlanSrv, $cookies, GlobalConfig, $state, WorkPlanModalSrv, GlobalSrv) {
    var createRoleVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))

    createRoleVm.isEditing = Boolean($stateParams.activityTypeId)
    createRoleVm.createOrEditModal = 'Creación'
    createRoleVm.startDate = null
    createRoleVm.endDate = null
    createRoleVm.minStartDate = new Date()
    createRoleVm.minEndDate = new Date()
    createRoleVm.rangeType = GlobalConfig.periods.rangeType
    createRoleVm.createOrEdit = 'Crear'
    createRoleVm.roles = []
    createRoleVm.dt_start = $cookies.get('wp_start')
    createRoleVm.dt_end = $cookies.get('wp_end')

    createRoleVm.typePeriod = []
    createRoleVm.periodsArray = []
    createRoleVm.selectedTypePeriod = {}
    createRoleVm.isTouchedPeriods = false

    createRoleVm.workplanId = currentUser.workplanId
    createRoleVm.teacherId = currentUser.teacherId
    createRoleVm.nameTeacher = currentUser.name
    createRoleVm.workplanTeacherActivityId = null
    createRoleVm.activityTypeId = null
    createRoleVm.detail = ''
    createRoleVm.unitsCombo = []
    createRoleVm.arrayUnit = []
    createRoleVm.rolesCombo = []
    createRoleVm.isSaveButtonDisabled = false
    createRoleVm.isFeedback = currentUser.isFeedback

    createRoleVm.addRole = addRole
    createRoleVm.funSelectedPeriod = funSelectedPeriod
    createRoleVm.confirmRoleAction = confirmRoleAction
    createRoleVm.validateForm = validateForm
    createRoleVm.validateCheklistPeriods = validateCheklistPeriods
    createRoleVm.rolesUnits = rolesUnits
    createRoleVm.exists = exists
    createRoleVm.showErrorMessages = showErrorMessages
    createRoleVm.hasError = hasError
    createRoleVm.changedCheckBox = changedCheckBox
    createRoleVm.addOrEditRol = addOrEditRol
    createRoleVm.startDateChange = startDateChange
    createRoleVm.close = close
    createRoleVm.percentage = 0

    createRoleVm.updateRangeType = (val) => {
      createRoleVm.rangeType = val
      createRoleVm.periodsArray = []
      createRoleVm.startDate = null
      createRoleVm.endDate = null
    }
    createRoleVm.updateRangeData = (val) => {
      createRoleVm.periodsArray = val['periods']
      createRoleVm.startDate = val['dates'][0]
      createRoleVm.endDate = val['dates'][1]
    }

    activate()

    function getPeriodsData () {
      let post = {
        workplanId: currentUser.workplanId,
        teacherId: currentUser.teacherId
      }
      WorkPlanSrv.getDataRolesList.getList(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createRoleVm.typePeriod = dataReturn.workplanperiod
          createRoleVm.unitsAndRolesCombo = dataReturn.rolesacademicunits
          createRoleVm.unitsCombo = dataReturn.rolesacademicunits
          createRoleVm.rolesCombo = dataReturn.rolesacademicunits
          // ////////////crear un array solo para la unidad//////////////
          rolesUnits()
          for (var index in createRoleVm.unitsCombo) {
            if (!exists(createRoleVm.unitsCombo[index].academitUnitId, createRoleVm.arrayUnit)) {
              var temp = {
                academitUnitId: createRoleVm.unitsCombo[index].academitUnitId,
                academitUnitName: createRoleVm.unitsCombo[index].academitUnitName
              }
              createRoleVm.arrayUnit.push(temp)
            }
          }
          // ///////////////////fin//////////////
        }
      }, function (data) {
        console.log(data)
      })
    }

    function rolesUnits () {
      createRoleVm.rolesCombo = []
      if (!createRoleVm.academicUnit) return

      let value = createRoleVm.academicUnit
      for (var index in createRoleVm.unitsAndRolesCombo) {
        if (createRoleVm.unitsAndRolesCombo[index].academitUnitId == value) {
          var temp = {
            roleId: createRoleVm.unitsAndRolesCombo[index].roleId,
            roleName: createRoleVm.unitsAndRolesCombo[index].roleName
          }
          createRoleVm.rolesCombo.push(temp)
        }
      }
    }

    function exists (value, array) {
      for (var index in array) {
        if (array[index].academitUnitId == value) {
          return true
        }
      }
      return false
    }

    function activate(){
      if(createRoleVm.isEditing){
          createRoleVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
          createRoleVm.activityTypeId = $stateParams.activityTypeId
          createRoleVm.createOrEdit = "Editar"
          getDataRoles().then(function(){
            getPeriodsData()
          })
      }
      else{
        getPeriodsData()
      }
      
    }

    function addRole (isExecution) {
      createRoleVm.isSaveButtonDisabled = true
      let origin = 1
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function getDataRoles () {
      let post = {
        workplanTeacherActivityId: parseInt($stateParams.workplanTeacherActivityId),
        activityTypeId: parseInt($stateParams.activityTypeId)
      }

      return WorkPlanSrv.getActivityDetailAcademic.getList(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createRoleVm.roles = dataReturn.data

          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function createJson (origin) {
      var assignment = {
        workplanTeacherActivityId: $stateParams.workplanTeacherActivityId,
        activityId: GlobalConfig.minorActivityId.roles,
        percentage: createRoleVm.percentage,
        description: createRoleVm.detail,
        teacherId: createRoleVm.teacherId,
        workplanId: createRoleVm.workplanId,
        roleId: createRoleVm.rolesSelected,
        academitUnitId: createRoleVm.academicUnit,
        timeRangeTypeId: createRoleVm.rangeType,
        userId: currentUser.id,
        origin: origin,
        isFeedbackActivity: createRoleVm.isFeedback
      }

      if (parseInt(createRoleVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createRoleVm.periodsArray) {
          var temp = {
            periodId: createRoleVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        assignment.periods = arrayPeriod
      } else {
        assignment.startDate = new Date(createRoleVm.startDate)
        assignment.endDate = new Date(createRoleVm.endDate)
      }

      if (createRoleVm.isEditing) {
        assignment.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
      }
      let aux = createRoleVm.rolesCombo.find((rolesName) => { return rolesName.roleId == assignment.roleId })
      assignment.name = aux.roleName
      addOrEditRol(assignment)
    }

    function addOrEditRol (assignment) {
      WorkPlanSrv.addRol.save(assignment).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getNotify(createRoleVm.teacherId, GlobalConfig.notificationType.inbox)
          getNotify(createRoleVm.teacherId, GlobalConfig.notificationType.email)
          confirmRoleAction()
        } else {
          createRoleVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function setValues (rol) {
      createRoleVm.academicUnit = rol.academicUnitId
      createRoleVm.rolesSelected = rol.roleId
      createRoleVm.activityTypeId = rol.activityTypeId
      createRoleVm.detail = rol.description
      createRoleVm.dt_start = moment(rol.startDate, 'YYYY-MM-DD').toDate()
      createRoleVm.dt_end = moment(rol.endDate, 'YYYY-MM-DD').toDate()
      createRoleVm.percentage = rol.percentage
      createRoleVm.roleId = rol.roleId
      createRoleVm.roleName = rol.roleName
      createRoleVm.rangeType = rol.timeRangeTypeId
      createRoleVm.periodsArray = []
      createRoleVm.selectedTypePeriod = {}

      if (createRoleVm.rangeType == GlobalConfig.periods.rangeType) {
        var splits = rol.periodId.split(',')
        createRoleVm.startDate = null
        createRoleVm.endDate = null
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createRoleVm.periodsArray.push(parseInt(valor))
          createRoleVm.selectedTypePeriod[valor] = true
        }
      }

      if (rol.startDate) {
        var startDateNew = moment(rol.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createRoleVm.minStartDate = moment(rol.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createRoleVm.isEditing = true
    }

    function validateForm (form) {
      return form.$invalid ||
             createRoleVm.validateCheklistPeriods()
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createRoleVm.periodsArray.includes(period.periodId)) {
          createRoleVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createRoleVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createRoleVm.periodsArray.splice(index, 1)
        }
      }
      createRoleVm.isTouchedPeriods = true
    }

    function validateCheklistPeriods () {
      return (createRoleVm.rangeType == GlobalConfig.periods.rangeType ? createRoleVm.periodsArray.length < 1 : false)
    }

    function confirmRoleAction () {
      let texts = GlobalConfig.appTexts
      let roleName = getActivityNameFromCombo()
      let actionEditOrCreate = texts.createDialog
      let textCreateOrEdit = texts.saved
      if (createRoleVm.isEditing) {
        actionEditOrCreate = texts.editDialog
        textCreateOrEdit = texts.modified
      }
      let header = {
        createOrEdit: actionEditOrCreate,
        textCreateOrEdit: textCreateOrEdit,
        itemName: roleName,
        nameModal: texts.modalTypeName.roleAcademicManagement,
        modalType: texts.modalTypeId.roleAcademicManagement
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function showErrorMessages (input) {
      if (input) {
        return input.$dirty || input.$touched
      } else {
        return false
      }
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function changedCheckBox () {
      for (var i = 0; i < createRoleVm.rolesCombo.length; i++) {
        createRoleVm.roleName = createRoleVm.rolesCombo[i].roleName
      }
    }

    function startDateChange () {
      let m = moment(createRoleVm.startDate)
      createRoleVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function getActivityNameFromCombo () {
      for (var i = 0; i < createRoleVm.rolesCombo.length; i++) {
        var row = createRoleVm.rolesCombo[i]
        if (row.roleId == createRoleVm.rolesSelected) {
          return createRoleVm.rolesCombo[i].roleName
        }
      }
    }

    function close () {
      $mdDialog.hide()
    }

    function getNotify(teacherId, notificationType){
      let data = {
        idTeacher: teacherId,
        dsName: 'Notificación, El profesor ' + currentUser.dsFullname + ' ha creado un nuevo rol',
        dsDescription: 'El profesor ' + currentUser.dsFullname + ' ha creado un nuevo rol el cual requiere de su validación, aprobación y registro en el sistema fuente',
        idNotification_delivery_type: notificationType,
        is_grouped: 1
      }
      
      GlobalSrv.sendNotificationAdminAM(data)
    }

  }// FIN DEL CONSTRUCTOR

  rbPlanifications (bool) {
    this.rangeType = Number(this.rangeType)
    if (bool) {
      this.startDate = null
      this.endDate = null
    } else {
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.startDate = null
      this.endDate = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }

}

CreateRoleCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$stateParams', 'WorkPlanSrv', '$cookies', 'GlobalConfig', '$state', 'WorkPlanModalSrv', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/roles/createRole/createRoleCtrl.js